import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useAuthStore } from './stores/auth.store';
import AuthPage from './pages/AuthPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import { tenantConfig } from './lib/tenant';
import DashboardLayout from './layouts/DashboardLayout';
import HomePage from './pages/HomePage';
import PageBuilder from './pages/PageBuilder';
import PageView from './pages/PageView';
import SettingsPage from './pages/SettingsPage';
import UserSettingsPage from './pages/UserSettingsPage';
import WorkspaceSettingsPage from './pages/WorkspaceSettingsPage';
import PricingPage from './pages/PricingPage';
import ChartDemo from './pages/ChartDemo';
import CalendarDemo from './pages/CalendarDemo';
import IconsDemo from './pages/IconsDemo';
import MetricIconsDemo from './pages/MetricIconsDemo';
import { ThemeProvider } from './components/theme-provider';
import PublicFormPage from './pages/PublicFormPage';

function App() {
  const { token } = useAuthStore();

  return (
    <ThemeProvider defaultTheme={tenantConfig.defaultTheme} storageKey="dashboard-theme">
      <BrowserRouter>
        <Routes>
          <Route path="/forms/:token" element={<PublicFormPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />

          {token ? (
            <>
              <Route path="/" element={<DashboardLayout />}>
                <Route index element={<HomePage />} />
                <Route path="pages/:slug" element={<PageView />} />
                <Route path="pages/:slug/edit" element={<PageBuilder />} />
                <Route path="pages/new" element={<PageBuilder />} />
                <Route path="settings" element={<SettingsPage />} />
                <Route path="integrations" element={<SettingsPage />} />
                <Route path="account" element={<UserSettingsPage />} />
                <Route path="plans" element={<PricingPage />} />
                <Route path="workspace/settings" element={<WorkspaceSettingsPage />} />
                <Route path="chart-demo" element={<ChartDemo />} />
                <Route path="calendar-demo" element={<CalendarDemo />} />
                <Route path="icons-demo" element={<IconsDemo />} />
                <Route path="metric-icons-demo" element={<MetricIconsDemo />} />
              </Route>
              <Route path="*" element={<Navigate to="/" replace />} />
            </>
          ) : (
            <Route path="*" element={<AuthPage />} />
          )}
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
